import React, { useState, useRef } from 'react';
import { useMutation, useQuery } from '@apollo/client/react';
import { Query } from '../../_common';
import { Table } from 'react-bootstrap';
import { useAuthContext } from '../../Auth/AuthProvider';
import { useStoreContext } from '../../App/StoreProvider';
import {
    GET_LOAD_ALLOCATION_SUMMARY,
    GET_ACTIVITY_SUMMARY,
    GET_ALL_DRIVERS_BY_REGION,
    GET_DRIVERS_IN_STANDBY,
    GET_DRIVER_ACTIVITY,
    GET_LOADID_AND_SANDPO,
    GET_STANDBY_DRIVERS,
} from '../../../graphql/client/queries';
import { ASSIGN_DRIVER_TO_LOAD } from '../../../graphql/client/mutations';
import * as Actions from '../../../store/actions/addLoadModal';
import {
    GetLoadAllocationSummary,
    GetLoadAllocationSummary_getLoadAllocationSummary as LoadAllocationSummary,
    AssignDriverToLoad,
    GetActivitySymmary_getActivitySummary as ActSummary,
    GetDriverActivity_getDriverActivity as DriverAct,
    GetStandbyDrivers_getStandbyDrivers as standByDrivers,
    GetDriversInStandby_getDriversInStandby as standbyDriversForAssigning,
} from '../../../types/schemaTypes';
import { Loading, Error } from '../../_common';
import { PermissionEnum } from '../../../types/PermissionEnum';
import './DailySandAllocations.scss';
import AssignStandByDriverModal from '../../../components/JobProfile/JobActivity/AssignStandByDriverModal/AssignStandByDriverModal';
import DispatchModal from '../../../components/AddLoads/DispatchModal';

interface DailySandAllocationsSummaryProps {
    jobId: number;
    jobName: string;
    date: string;
    refreshed: boolean;
    setRefreshed: React.Dispatch<React.SetStateAction<boolean>>;
}

const DailySandAllocationsSummary = ({
    jobId,
    jobName,
    date,
    refreshed,
    setRefreshed,
}: DailySandAllocationsSummaryProps): React.ReactElement => {
    const authContext = useAuthContext();
    const [state, dispatch] = useStoreContext();
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = localStorage.getItem('Jobdetails-TabName') + '';
    const [showAssignDriverModal, setShowAssignDriverModal] = useState(false);
    const [proppant, setProppant] = useState<string | null>('');
    const [sandPO, setSandPO] = useState<string | null>('');
    const [transportationPO, setTransportationPO] = useState<string | null>('');
    const [lofa, setLofa] = useState<string | null>('');
    const [proppantId, setProppantId] = useState<number | null>(0);
    const [lofaId, setLofaId] = useState<number | null>(0);
    const [regionId, setRegionId] = useState<number | null>(0);
    const [showDispatchModal, setShowDispatchModal] = useState<boolean>(false);
    const isCurrentActivityEnabled = authContext.userHasPermission(PermissionEnum.SandAllocationAssignDriver);
    const {
        currentActivity: { filters, searchPhrase, searchPhraseSubset },
    } = state;

    const variables = {
        input: {
            jobId: jobId,
            date: date,
        },
    };
    const [assignDriver, { loading: mutationLoading }] = useMutation<AssignDriverToLoad>(ASSIGN_DRIVER_TO_LOAD, {
        refetchQueries: [
            {
                query: GET_LOAD_ALLOCATION_SUMMARY,
                variables: {
                    input: {
                        jobId: jobId,
                        date: date,
                    },
                },
            },
        ],
    });

    const handleOnClickAssign = async (driverId, driverName, loadId): Promise<void> => {
        await dispatch(Actions.setCreatedLoadIds([loadId ?? -1]));
        await dispatch(Actions.assignDriverToLoadId(loadId, driverName, driverId, true, driverName));
        setShowAssignDriverModal(false);
        setShowDispatchModal(true);
        await assignDriver({
            variables: { driverId: driverId, loadId: loadId, isPrimaryDriver: true },
        });
        setProppantId(null);
    };

    return (
        <Query<GetLoadAllocationSummary> query={GET_LOAD_ALLOCATION_SUMMARY} variables={variables} fetchPolicy="network-only">
            {({
                loading,
                error,
                data,
                refetch,
            }): React.ReactElement | null => {

                React.useEffect(()=>{
                    if (refreshed) {
                        refetch();
                        setRefreshed(false);
                    }
                },[refreshed]);
                if (loading) {
                    return (
                        <div className="DailySandAllocations-Spinner-Container">
                            <Loading />
                        </div>
                    );
                }
              
                

                if (error) {
                    return <Error error={error} />;
                }

                const loadAllocationSummaryObj: Record<string, LoadAllocationSummary[]> = {};
                const summaryList = data?.getLoadAllocationSummary ?? [];
                if (summaryList.length > 0) {
                    (summaryList as (LoadAllocationSummary | null)[]).forEach((element: LoadAllocationSummary | null): void => {
                        if (element != null && element.proppantName != null) {
                            const key = element.proppantName;
                            if (key in loadAllocationSummaryObj) {
                                loadAllocationSummaryObj[key].push(element);
                            } else {
                                loadAllocationSummaryObj[key] = [element];
                            }
                        }
                    });
                }

                return (
                    <div>
                        {Object.keys(loadAllocationSummaryObj).length !== 0 ? (
                            <Table bordered className="DailySandAllocationSummaryTable">
                                <thead>
                                    <tr className="DailySandAllocationSummaryTable-Header">
                                        <th>Proppant</th>
                                        <th>Loading Facility</th>
                                        <th>Sand PO</th>
                                        <th>Transportation PO</th>
                                        <th>Planned Weight</th>
                                        <th>Dispatched Weight</th>
                                        <th>Actual Weight</th>
                                        <th>Remaining Weight</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.keys(loadAllocationSummaryObj).map(proppant => {
                                        const loadAllocationSummaries: LoadAllocationSummary[] =
                                            loadAllocationSummaryObj[proppant];
                                        let plannedWeightTotal = 0;
                                        let actualWeightTotal = 0;
                                        let dispatchWeightTotal = 0;
                                        let remainingWeightTotal = 0;
                                        return (
                                            <>
                                                {loadAllocationSummaries.map((loadAllocationSummary, index) => {
                                                    loadAllocationSummary.plannedWeight &&
                                                        (plannedWeightTotal =
                                                            plannedWeightTotal + loadAllocationSummary.plannedWeight);
                                                    loadAllocationSummary.actualWeight &&
                                                        (actualWeightTotal =
                                                            actualWeightTotal + loadAllocationSummary.actualWeight);
                                                    loadAllocationSummary.dispatchedWeight &&
                                                        (dispatchWeightTotal =
                                                            dispatchWeightTotal +
                                                            loadAllocationSummary.dispatchedWeight);
                                                    loadAllocationSummary.remainingWeight &&
                                                        (remainingWeightTotal =
                                                            remainingWeightTotal +
                                                            loadAllocationSummary.remainingWeight);
                                                    return (
                                                        <tr key={index}>
                                                            {index === 0 && (
                                                                <td
                                                                    className="DailySandAllocationsSummary-Proppant"
                                                                    rowSpan={loadAllocationSummaries.length}
                                                                >
                                                                    {proppant}
                                                                </td>
                                                            )}
                                                            <td>{loadAllocationSummary.lofaName}</td>
                                                            <td>{loadAllocationSummary.sandPO}</td>
                                                            <td>{loadAllocationSummary.transportationPO}</td>
                                                            <td>{loadAllocationSummary.plannedWeight?.toFixed(2)}</td>
                                                            <td>
                                                                {loadAllocationSummary.dispatchedWeight?.toFixed(2)}
                                                            </td>
                                                            <td>{loadAllocationSummary.actualWeight?.toFixed(2)}</td>
                                                            <td>{loadAllocationSummary.remainingWeight?.toFixed(2)}</td>
                                                            <td>
                                                                {loadAllocationSummary.createdLoads &&
                                                                loadAllocationSummary.createdLoads > 0 ? (
                                                                    <>
                                                                        {isCurrentActivityEnabled ? (
                                                                            <>
                                                                                {' '}
                                                                                <div
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => {
                                                                                        setShowAssignDriverModal(true);
                                                                                        setProppant(
                                                                                            loadAllocationSummary.proppantName,
                                                                                        );
                                                                                        setSandPO(
                                                                                            loadAllocationSummary.sandPO,
                                                                                        );
                                                                                        setTransportationPO(
                                                                                            loadAllocationSummary.transportationPO,
                                                                                        );
                                                                                        setLofa(
                                                                                            loadAllocationSummary.lofaName,
                                                                                        );
                                                                                        setProppantId(
                                                                                            loadAllocationSummary.proppantId,
                                                                                        );
                                                                                        setLofaId(
                                                                                            loadAllocationSummary.lofaId,
                                                                                        );
                                                                                        setRegionId(
                                                                                            loadAllocationSummary.regionId,
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <i className="material-icons Add-Load-Icon">
                                                                                        add_circle
                                                                                    </i>
                                                                                    <span className="Add-Load-Link">
                                                                                        Assign Driver
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}

                                                <tr className="DailySandAllocations-Footer">
                                                    <td className="DailySandAllocationsSummary-Total">{`Total ${proppant}`}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="DailySandAllocationsSummary-Total">
                                                        {plannedWeightTotal?.toFixed(2)}
                                                    </td>
                                                    <td className="DailySandAllocationsSummary-Total">
                                                        {dispatchWeightTotal?.toFixed(2)}
                                                    </td>
                                                    <td className="DailySandAllocationsSummary-Total">
                                                        {actualWeightTotal?.toFixed(2)}
                                                    </td>
                                                    <td className="DailySandAllocationsSummary-Total">
                                                        {remainingWeightTotal?.toFixed(2)}
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            </>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        ) : (
                            <div className="NoResult-Second-Title-Primary">No Sand Allocation Summary found.</div>
                        )}
                        {jobId && lofaId && proppantId ? (
                            <AssignStandByDriverModal
                                show={showAssignDriverModal}
                                proppant={proppant}
                                sandPO={sandPO}
                                transportationPO={transportationPO}
                                lofa={lofa}
                                jobName={jobName}
                                jobId={jobId}
                                proppantId={proppantId}
                                lofaId={lofaId}
                                regionId={regionId}
                                onClickBack={() => {
                                    setShowAssignDriverModal(false);
                                    setProppantId(null);
                                }}
                                onClickAssign={(driverId, driverName, loadId) =>
                                    handleOnClickAssign(driverId, driverName, loadId)
                                }
                                mutationLoading={mutationLoading}
                            />
                        ) : (
                            ''
                        )}
                        <DispatchModal
                            isFromLoads={true}
                            isSplitLoad={false}
                            show={showDispatchModal}
                            onClickHide={() => setShowDispatchModal(false)}
                        />
                    </div>
                );
            }}
        </Query>
    );
};

export default DailySandAllocationsSummary;
